import React from "react";
import { Modal } from "../components";

interface DialogProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  isOpen: boolean;
  onRequestClose?: () => void;
}

export function Dialog(props: DialogProps) {
  const { isOpen, children, onRequestClose, header, footer } = props;

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} transparent>
      <div className="dialog-root">
        <div onClick={onRequestClose} className="dialog-overlay" />
        <div className="dialog-wrapper">
          {header}
          <div className="dialog-body">{children}</div>
          {footer}
        </div>
      </div>
    </Modal>
  );
}
